import { useRef } from 'react';
import { SectionRefs } from '../types/SectionRefs';

const useSectionRefs = (): SectionRefs => {
  const header = useRef<HTMLDivElement>(null);
  const start = useRef<HTMLDivElement>(null);
  const services = useRef<HTMLDivElement>(null);
  const start2 = useRef<HTMLDivElement>(null);
  const cloud = useRef<HTMLDivElement>(null);
  const commitment = useRef<HTMLDivElement>(null);
  const expertise = useRef<HTMLDivElement>(null);
  const ai = useRef<HTMLDivElement>(null);
  const contact = useRef<HTMLDivElement>(null);
  const blog = useRef<HTMLDivElement>(null);
  const newsletter = useRef<HTMLDivElement>(null);

  return {
    header,
    start,
    services,
    start2,
    cloud,
    commitment,
    expertise,
    ai,
    contact,
    blog,
    newsletter,
  };
};

export default useSectionRefs;